var $3b77288cc2b064c6$exports = {};
$3b77288cc2b064c6$exports = {
    "more": `\u{41E}\u{449}\u{435} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{438}`
};


export {$3b77288cc2b064c6$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
